export interface HandleErrorsGlobalRecord {
  DEFAULT: unknown;
  [P: string]: unknown;
}
